// src/components/Sections/ScoringExperienceSection/ScoringExperienceSection.jsx

import React from 'react';
import './ScoringExperienceSection.scss';

import teeOffScreenshot from '../../../assets/images/marketing/ttg-tee-off-phone.png';
import scoringScreenshot from '../../../assets/images/marketing/ttg-live-scoring-phone.png';
import scorecardScreenshot from '../../../assets/images/marketing/ttg-round-scorecard-phone.png';

import useInView from '../../../hooks/useInView';

const scoringFields = [
  'Score',
  'Fairway',
  'Green in regulation',
  'Putting'
];

export default function ScoringExperienceSection() {
  const {
    ref,
    isVisible
  } = useInView({
    threshold: 0.22
  });

  return (
    <section
      id="how-it-plays"
      ref={ref}
      className={`
        round-v4
        section-v2
        motion-section
        ${isVisible ? 'is-visible' : ''}
      `}
    >
      <div className="container round-v4__layout">
        <div className="round-v4__copy motion-copy">
          <p className="eyebrow">
            01 · Your round
          </p>

          <h2>
            Keep score. Keep playing.
          </h2>

          <p className="round-v4__lead">
            Choose your course and tees, enter your score hole by hole,
            and track useful basics like fairways, greens, and putts.
            Keep a record of the round without turning golf into data entry.
          </p>

          <div
            className="score-fields"
            aria-label="Simple scoring inputs"
          >
            {scoringFields.map((field) => (
              <span key={field}>
                {field}
              </span>
            ))}
          </div>

          <p className="experience-quote">
            Like a paper scorecard, with a season behind it.
          </p>
        </div>

        <div className="round-v4__visual">
          <span
            className="round-v4__hole-number"
            aria-hidden="true"
          >
            12
          </span>

          <div
            className="round-v4__scorecard"
            aria-hidden="true"
          >
            <div className="round-v4__scorecard-top">
              <span>
                The Tour Golfers
              </span>

              <small>
                Member Scorecard
              </small>
            </div>

            <div className="round-v4__scorecard-grid">
              <strong>
                HOLE
              </strong>

              <span>1</span>
              <span>2</span>
              <span>3</span>
              <span>4</span>
              <span>5</span>
              <span>6</span>
              <span>7</span>
              <span>8</span>
              <span>9</span>

              <strong>
                PAR
              </strong>

              <span>4</span>
              <span>5</span>
              <span>3</span>
              <span>4</span>
              <span>4</span>
              <span>3</span>
              <span>5</span>
              <span>4</span>
              <span>4</span>
            </div>
          </div>

          <div
            className="round-v4__route"
            aria-hidden="true"
          >
            <span></span>

            <i></i>
            <i></i>
            <i></i>
          </div>

          {/* SET UP */}

          <div className="round-v4__step round-v4__step--setup">
            <div className="round-v4__step-label">
              <span>
                01
              </span>

              <strong>
                Set up
              </strong>

              <small>
                Course + tees
              </small>
            </div>

            <figure>
              <img
                src={teeOffScreenshot}
                alt="The Tour Golfers tee-off setup screen"
                loading="lazy"
              />
            </figure>
          </div>

          {/* PLAY */}

          <div className="round-v4__step round-v4__step--play">
            <div className="round-v4__step-label">
              <span>
                02
              </span>

              <strong>
                Play
              </strong>

              <small>
                Simple scoring
              </small>
            </div>

            <figure>
              <img
                src={scoringScreenshot}
                alt="The Tour Golfers live scoring screen"
                loading="lazy"
              />
            </figure>
          </div>

          {/* REVIEW */}

          <div className="round-v4__step round-v4__step--review">
            <div className="round-v4__step-label">
              <span>
                03
              </span>

              <strong>
                Review
              </strong>

              <small>
                Your round
              </small>
            </div>

            <figure>
              <img
                src={scorecardScreenshot}
                alt="The Tour Golfers completed round scorecard"
                loading="lazy"
              />
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}